import categoryService from "app/common/services/categoryService";
import { getCategoryDetailsForDashboard } from "app/pages/industry-analysis/category-share/CategoryShareGraph/utils/CategoryShareGraphUtils";
import { AddToDashboard } from "app/components/dashboard/AddToDashboard/AddToDashboard";

export const AddToDashboardWrapper = ({ filtersStateObject, params }) => {
    const { category, webSource } = params;

    const overrideAddToDashboardParams = {
        ...filtersStateObject,
        key: [getCategoryDetailsForDashboard({ category }, { categoryService })],
        family: "Industry",
    };
    return (
        <AddToDashboard
            modelType="fromIndustry"
            webSource={webSource}
            type="TopSitesTable"
            metric={"TopSitesExtended"}
            overrideAddToDashboardParams={overrideAddToDashboardParams}
            industryQueryParams={category}
        />
    );
};
